import { render } from "./LiveControls.vue?vue&type=template&id=70d135a1&scoped=true"
import script from "./LiveControls.vue?vue&type=script&lang=ts"
export * from "./LiveControls.vue?vue&type=script&lang=ts"

import "./LiveControls.vue?vue&type=style&index=0&id=70d135a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70d135a1"

export default script